import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Justificacion } from 'src/app/models/rrhh/justificacion.model';
import { UserValuesService } from 'src/app/services/utils/user-values.service';
import { NovedadesService } from 'src/app/services/rrhh/novedades/novedades.service';
import { SnackBarService } from 'src/app/services/utils/snackBar.service';
import { CmbEntity } from 'src/app/models/general/cmbEntity.model';
import { ModalConfirmacionComponent } from '../../modals/modal-confirmacion/modal-confirmacion.component';
import { ModalNominaComponent } from '../../modals/modal-nomina/modal-nomina.component';
import { Nomina } from 'src/app/models/rrhh/nomina.model';
import { ResponseHelper } from 'src/app/models/sistema/responseHelper';
import { ParamEntity } from 'src/app/models/general/param.model';
import { Aviso } from 'src/app/models/rrhh/aviso.model';

@Component({
  selector: 'app-avisos',
  templateUrl: './avisos.component.html',
  styleUrls: ['./avisos.component.scss']
})
export class AvisosComponent implements OnInit {

  startDateValue;
  endDateValue;
  displayedColumns: string[] = [
    'idAviso',
    'fecha',
    'nIncidencia',
    'observaciones',
    'nPatologia',
    'nEstado',
    'fum',
    'nUsuario',
    'esHumand',
    'urlDocumento',
    'justificar',
    'accion'
  ];

  dataSourceAviso = new MatTableDataSource<Aviso>([]);
  @ViewChild(MatPaginator, { static: true }) set matPaginator(paginator: MatPaginator) {
    this.dataSourceAviso.paginator = paginator;
  }
  aviso: Aviso;
  listIncidenciasCmb: CmbEntity[] = [];
  listPatologiasCmb: CmbEntity[] = [];
  fechaCalculadaRetorno = '';
  fechaCalculadaHasta = '';
  justificacionesList: Justificacion[] = [];
  menuMarcacionOpened = false;
  dateInput: any = '';
  fechaPicker: Date;
  cmbPatologiaHabilitado: boolean;

  constructor(
    private userValuesService: UserValuesService,
    private novedadesService: NovedadesService,
    private dialog: MatDialog,
    private _snackBar: SnackBarService
  ) { }

  ngOnInit() {
    this.aviso = new Aviso();
    this.getIncidenciasCmb();
    this.getPatologiasCmb();
  }

  getStartDatePickerEmit(value?) {
    this.fechaPicker = value;
    this.calculaFecha(this.fechaPicker);
  }

  getEndDatePickerEmit(value?) {
    this.endDateValue = value;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceAviso.filter = filterValue.trim().toLowerCase();
  }

  getSeleccionIncidencia(e) {
    this.aviso.IdIncidencia = e.value;
    this.setMostrarCmbPatologia();
  }

  getSeleccionPatologia(e) {
    this.aviso.IdPatologia = e.value;
  }

  getPatologiasCmb() {
    let paramEntity = new ParamEntity<Justificacion>();
    paramEntity.GenericEntity = new Justificacion();
    paramEntity.IdEmpresa = this.userValuesService.getUsuarioValues.IdEmpresa;
    paramEntity.IdLegajo = this.aviso.IdLegajo;
    paramEntity.FechaDate = this.aviso.FechaDesde;
    paramEntity.IdPatologia = 0;

    this.novedadesService.getListPatologias(paramEntity).subscribe((result: CmbEntity[]) => {
      this.listPatologiasCmb = result;
    });
  }

  getIncidenciasCmb() {
    let params = [];
    params.push(null);
    params.push(this.userValuesService.getUsuarioValues.IdUsuario);
    params.push(this.userValuesService.getUsuarioValues.IdEmpresa);

    this.novedadesService.getListIncidencias(params).subscribe((result: CmbEntity[]) => {
      this.listIncidenciasCmb = result;
    });
  }

  getAvisosGrilla(idLegajo) {
    console.log('[GRILLA] Inicio getAvisosGrilla para legajo:', idLegajo);
    const paramEntity = new ParamEntity<any>();
    paramEntity.IdEmpresa = this.userValuesService.getUsuarioValues.IdEmpresa;
    paramEntity.IdUsuario = this.userValuesService.getUsuarioValues.IdUsuario;
    paramEntity.IdLegajo = idLegajo;
    console.log('[GRILLA] Parámetros consulta:', paramEntity);

this.novedadesService.getNovedadesAvisosGrilla(paramEntity).subscribe((result: Aviso[]) => {
  console.log('[GRILLA] Respuesta recibida - Total registros:', result?.length);
  console.log('[GRILLA] Datos completos:', result);

  // Preprocesa URLs de cada fila
  const dataProcesada = result.map(item => {
    const docs = item.UrlDocumento
      ? item.UrlDocumento
          .split('|||')
          .map(d => d.trim())
          .filter(d => d.length > 0)
      : [];

    return {
      ...item,
      documentos: docs
    };
  });

  this.dataSourceAviso.data = dataProcesada;
  console.log('[GRILLA] DataSource actualizado. Total filas:', this.dataSourceAviso.data.length);

  setTimeout(() => {
    if (this.dataSourceAviso.paginator) {
      this.dataSourceAviso.paginator.firstPage();
    }    this.dataSourceAviso._updateChangeSubscription();
  });

},
(error) => {
  console.error('[GRILLA] Error al obtener avisos:', error);
});

  }

  guardarAviso() {
    const paramEntity = new ParamEntity<Aviso>();
    this.aviso.FechaDesde = this.fechaPicker;
    paramEntity.GenericEntity = this.aviso;
    paramEntity.GenericEntity.IdNovIncidencia = 0;
    paramEntity.GenericEntity.IdEstado = 1;
    paramEntity.IdLegajo = this.aviso.IdLegajo;
    paramEntity.IdEmpresa = this.userValuesService.getUsuarioValues.IdEmpresa;
    paramEntity.IdUsuario = this.userValuesService.getUsuarioValues.IdUsuario;

    this.novedadesService.guardarAviso(paramEntity).subscribe((result: ResponseHelper) => {
      if (result.Ok) {
        this._snackBar.openSnackBar('snack-success', 'Aviso guardado correctamente', 3000);
        this.getAvisosGrilla(paramEntity.IdLegajo);
        this.limpiarObjeto();
        this.dateInput = this.dateInput = new Date();
        this.calculaFecha(this.fechaPicker);
      } else {
        this._snackBar.openSnackBar('snack-danger', result.Mensaje, 3000);
      }
    }, (error) => { this._snackBar.openSnackBar('snack-danger', error.error, 3000); });
  }

  anularAviso(row: Aviso) {
    const paramEntity = new ParamEntity<Aviso>();
    paramEntity.GenericEntity = { ...row };
    paramEntity.GenericEntity.IdEstado = 0;

    paramEntity.IdLegajo = row.IdLegajo;
    paramEntity.IdEmpresa = this.userValuesService.getUsuarioValues.IdEmpresa;
    paramEntity.IdUsuario = this.userValuesService.getUsuarioValues.IdUsuario;

    const idLegajoTemp = this.aviso.IdLegajo;
    console.log('idLegajo enviado:', idLegajoTemp);

    this.novedadesService.anularAviso(paramEntity).subscribe(
      (result: ResponseHelper) => {
        if (result.Ok) {
          this._snackBar.openSnackBar('snack-success', 'Aviso anulado correctamente', 3000);
          this.getAvisosGrilla(idLegajoTemp);
        }
      },
      (error) => {
        this._snackBar.openSnackBar('snack-danger', error.error, 3000);
      }
    );
  }




  limpiarObjeto() {
    const nuevoAviso = new Justificacion();
    Object.assign(nuevoAviso, this.aviso);
    this.aviso = new Aviso();
    this.aviso.IdLegajo = nuevoAviso.IdLegajo;
    this.aviso.Nombre = nuevoAviso.Nombre;
    this.aviso.Apellido = nuevoAviso.Apellido;
    this.aviso.Seccion = nuevoAviso.Seccion;
  }

  justificarAvisoHumand(avisoHumand: Aviso) {
    console.log('[JUSTIFICAR] Inicio - Aviso Humand:', avisoHumand);
    
    if (!avisoHumand.IdIncidenciaJustif) {
      console.error('[JUSTIFICAR] Error: No existe IdIncidenciaJustif en el aviso');
      this._snackBar.openSnackBar('snack-danger', 
        'No existe incidencia de justificación configurada para este tipo de aviso', 
        4000);
      return;
    }

    if (!avisoHumand.IdAviso || avisoHumand.IdAviso === 0) {
      console.error('[JUSTIFICAR] Error: No existe IdAviso');
      this._snackBar.openSnackBar('snack-danger', 
        'Error: No se pudo identificar el aviso original', 
        4000);
      return;
    }

    console.log('[JUSTIFICAR] Obteniendo datos completos del aviso IdAviso:', avisoHumand.IdAviso);

    // Obtener los datos originales del aviso desde la tabla de avisos
    const paramAviso = new ParamEntity<any>();
    paramAviso.IdEmpresa = this.userValuesService.getUsuarioValues.IdEmpresa;
    paramAviso.IdUsuario = this.userValuesService.getUsuarioValues.IdUsuario;
    paramAviso.IdLegajo = this.aviso.IdLegajo;
    
    // Buscar el aviso original en la grilla actual (todas las filas con mismo IdAviso)
    const filasDelAviso = this.dataSourceAviso.data.filter(a => a.IdAviso === avisoHumand.IdAviso);
    
    if (filasDelAviso.length === 0) {
      console.error('[JUSTIFICAR] No se encontraron filas del aviso en la grilla');
      this._snackBar.openSnackBar('snack-danger', 'Error: No se encontró el aviso completo', 4000);
      return;
    }

    // Ordenar por FechaDate (que es Date) para obtener el primero (fecha más antigua)
    filasDelAviso.sort((a, b) => {
      const fechaA = new Date(a.FechaDate || a.FechaDesde).getTime();
      const fechaB = new Date(b.FechaDate || b.FechaDesde).getTime();
      return fechaA - fechaB;
    });
    const avisoCompleto = filasDelAviso[0];
    
    console.log('[JUSTIFICAR] Aviso completo (primer día):', avisoCompleto);
    console.log('[JUSTIFICAR] Total de días del aviso:', filasDelAviso.length);
    console.log('[JUSTIFICAR] FechaDate primer día:', avisoCompleto.FechaDate);
    console.log('[JUSTIFICAR] FechaDesde primer día:', avisoCompleto.FechaDesde);
    console.log('[JUSTIFICAR] Todas las filas del aviso:', filasDelAviso.map(f => ({ IdIncidencia: f.IdIncidencia, Nincidencia: f.Nincidencia })));

    // IMPORTANTE: Usar el IdIncidencia de la incidencia original del aviso Humand
    // buscando en todas las filas del mismo IdAviso para encontrar la incidencia correcta
    let idIncidenciaOriginal = avisoCompleto.IdIncidencia;
    
    // Verificar si alguna fila tiene IdIncidencia definido (es el aviso de Humand original)
    const filaConIncidencia = filasDelAviso.find(f => f.IdIncidencia > 0 && f.IdAviso > 0);
    if (filaConIncidencia) {
      idIncidenciaOriginal = filaConIncidencia.IdIncidencia;
      console.log('[JUSTIFICAR] Usando IdIncidencia de fila con IdIncidencia:', filaConIncidencia.IdIncidencia);
    } else {
      console.log('[JUSTIFICAR] Usando IdIncidencia del primer día:', idIncidenciaOriginal);
    }

    const paramIncidencias = new ParamEntity<any>();
    paramIncidencias.IdEmpresa = this.userValuesService.getUsuarioValues.IdEmpresa;
    paramIncidencias.IdUsuario = this.userValuesService.getUsuarioValues.IdUsuario;
    paramIncidencias.IdIncidencia = idIncidenciaOriginal;

    console.log('[JUSTIFICAR] Parámetros consulta incidencias:', paramIncidencias);

    this.novedadesService.getIncidenciasJustificacionesPorIncidencia(paramIncidencias).subscribe(
      (justificaciones: CmbEntity[]) => {
        console.log('[JUSTIFICAR] Justificaciones obtenidas:', justificaciones);
        console.log('[JUSTIFICAR] IdIncidencia solicitado:', idIncidenciaOriginal);
        console.log('[JUSTIFICAR] Total justificaciones recibidas:', justificaciones.length);
        
        if (justificaciones && justificaciones.length > 0) {
          // Pasar el aviso completo con días totales
          // Usar FechaDate o FechaDesde (lo que esté disponible)
          const primerDia = filasDelAviso[0];
          const ultimoDia = filasDelAviso[filasDelAviso.length - 1];
          
          const avisoParaModal = {
            ...avisoCompleto,
            DiasTotal: filasDelAviso.length,
            FechaDesdeOriginal: primerDia.FechaDate || primerDia.FechaDesde,
            FechaHastaOriginal: ultimoDia.FechaDate || ultimoDia.FechaDesde
          };
          
          console.log('[JUSTIFICAR] Aviso para modal:', avisoParaModal);
          this.mostrarModalJustificacion(avisoParaModal, justificaciones);
        } else {
          console.error('[JUSTIFICAR] No se encontraron justificaciones para el agrupador');
          this._snackBar.openSnackBar('snack-danger', 
            'No se encontraron incidencias de justificación para este agrupador', 
            4000);
        }
      },
      (error) => {
        console.error('[JUSTIFICAR] Error al obtener incidencias:', error);
        this._snackBar.openSnackBar('snack-danger', 
          'Error al obtener incidencias de justificación', 
          3000);
      }
    );
  }

  mostrarModalJustificacion(avisoHumand: any, justificaciones: CmbEntity[]) {
    console.log('[MODAL] Mostrando modal con justificaciones:', justificaciones);
    console.log('[MODAL] Aviso completo:', avisoHumand);
    console.log('[MODAL] FechaDesdeOriginal:', avisoHumand.FechaDesdeOriginal);
    console.log('[MODAL] FechaHastaOriginal:', avisoHumand.FechaHastaOriginal);
    console.log('[MODAL] FechaDate:', avisoHumand.FechaDate);
    console.log('[MODAL] FechaDesde:', avisoHumand.FechaDesde);
    
    // Usar FechaDate o FechaDesde (lo que esté disponible)
    const fechaDesde = new Date(avisoHumand.FechaDesdeOriginal || avisoHumand.FechaDate || avisoHumand.FechaDesde);
    const fechaHasta = new Date(avisoHumand.FechaHastaOriginal || avisoHumand.FechaDate || avisoHumand.FechaDesde);
    const diasAviso = avisoHumand.DiasTotal || avisoHumand.Dias || 1;
    
    console.log('[MODAL] Fechas procesadas:', {
      desde: fechaDesde,
      hasta: fechaHasta,
      dias: diasAviso
    });
    
    // Validar que las fechas sean válidas
    if (isNaN(fechaDesde.getTime()) || isNaN(fechaHasta.getTime())) {
      console.error('[MODAL] Error: Fechas inválidas', {
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta
      });
      this._snackBar.openSnackBar('snack-danger', 
        'Error: No se pudieron calcular las fechas del aviso', 
        4000);
      return;
    }
    
    const fechaRetorno = new Date(fechaHasta);
    fechaRetorno.setDate(fechaRetorno.getDate() + 1);

    const infoFechas = {
      desde: fechaDesde,
      hasta: fechaHasta,
      dias: diasAviso,
      retorno: fechaRetorno
    };

    console.log('[MODAL] Info fechas:', infoFechas);

    // Verificar si hay incidencias que requieren patología
    const requierePatologia = justificaciones.some(j => j.IdPreSet === 1);
    console.log('[MODAL] Requiere patología:', requierePatologia);
    
    if (justificaciones.length === 1) {
      const mensaje = `¿Confirma justificar el aviso Humand con:\n\n${justificaciones[0].Detalle}?`;
      
      const dialogRef = this.dialog.open(ModalConfirmacionComponent, {
        width: '600px',
        autoFocus: false,
        data: {
          titulo: mensaje,
          esHtml: false,
          infoFechas: infoFechas,
          mostrarPatologias: justificaciones[0].IdPreSet === 1,
          patologias: justificaciones[0].IdPreSet === 1 ? this.listPatologiasCmb : [],
          idIncidenciaSeleccionada: justificaciones[0].Id
        }
      });
      
      dialogRef.beforeClosed().subscribe((result) => {
        console.log('[MODAL] Resultado (1 opción):', result);
        if (result && result.confirmado) {
          this.ejecutarJustificacionDesdeAviso(
            avisoHumand, 
            justificaciones[0].Id, 
            result.idPatologiaSeleccionada
          );
        }
      });
    } else {
      const dialogRef = this.dialog.open(ModalConfirmacionComponent, {
        width: '650px',
        autoFocus: false,
        data: {
          titulo: 'Seleccione la incidencia con la que desea justificar:',
          opciones: justificaciones,
          esSeleccion: true,
          infoFechas: infoFechas,
          mostrarPatologias: requierePatologia,
          patologias: this.listPatologiasCmb
        }
      });
      
      dialogRef.beforeClosed().subscribe((result) => {
        console.log('[MODAL] Resultado (múltiples opciones):', result);
        if (result && result.idIncidenciaSeleccionada) {
          this.ejecutarJustificacionDesdeAviso(
            avisoHumand, 
            result.idIncidenciaSeleccionada,
            result.idPatologiaSeleccionada
          );
        }
      });
    }
  }

  ejecutarJustificacionDesdeAviso(avisoHumand: any, idIncidenciaJustif: number, idPatologia?: number) {
    console.log('[EJECUTAR] Inicio ejecución justificación');
    console.log('[EJECUTAR] Aviso Humand:', avisoHumand);
    console.log('[EJECUTAR] ID Incidencia Justif seleccionada:', idIncidenciaJustif);
    console.log('[EJECUTAR] ID Patología seleccionada:', idPatologia);

    const idLegajo = this.aviso.IdLegajo || avisoHumand.IdLegajo;
    
    console.log('[EJECUTAR] IdLegajo a usar:', idLegajo);

    if (!idLegajo || idLegajo === 0) {
      console.error('[EJECUTAR] Error: IdLegajo es 0 o undefined');
      this._snackBar.openSnackBar('snack-danger', 'Error: No se pudo obtener el legajo', 3000);
      return;
    }

    const paramEntity = new ParamEntity<Justificacion>();
    paramEntity.GenericEntity = new Justificacion();
    
    // Usar FechaDate o FechaDesde (lo que esté disponible)
    const fechaDesde = new Date(avisoHumand.FechaDesdeOriginal || avisoHumand.FechaDate || avisoHumand.FechaDesde);
    const fechaHasta = new Date(avisoHumand.FechaHastaOriginal || avisoHumand.FechaDate || avisoHumand.FechaDesde);
    const diasTotal = avisoHumand.DiasTotal || avisoHumand.Dias || 1;
    
    console.log('[EJECUTAR] Fechas calculadas:', {
      fechaDesde: fechaDesde,
      fechaHasta: fechaHasta,
      diasTotal: diasTotal
    });
    
    paramEntity.GenericEntity.FechaDesde = fechaDesde;
    paramEntity.GenericEntity.IdIncidencia = idIncidenciaJustif;
    paramEntity.GenericEntity.Dias = diasTotal;
    
    // Agregar leyenda en observaciones
    const observacionOriginal = avisoHumand.Observaciones || '';
    const leyendaJustificacion = 'Aviso Humand Justificado';
    paramEntity.GenericEntity.Observaciones = observacionOriginal 
      ? `${observacionOriginal} - ${leyendaJustificacion}` 
      : leyendaJustificacion;
    
    // Agregar patología si fue seleccionada
    paramEntity.GenericEntity.IdPatologia = idPatologia || avisoHumand.IdPatologia || 0;
    
    paramEntity.GenericEntity.IdJustificacion = 0;
    paramEntity.GenericEntity.IdEstado = 0;
    paramEntity.GenericEntity.Anula = false;
    
    paramEntity.IdLegajo = idLegajo;
    paramEntity.IdEmpresa = this.userValuesService.getUsuarioValues.IdEmpresa;
    paramEntity.IdUsuario = this.userValuesService.getUsuarioValues.IdUsuario;
    
    paramEntity.FechaDateArray[0] = fechaDesde;
    paramEntity.FechaDateArray[1] = fechaHasta;

    console.log('[EJECUTAR] ParamEntity armado:', {
      IdLegajo: paramEntity.IdLegajo,
      IdEmpresa: paramEntity.IdEmpresa,
      IdUsuario: paramEntity.IdUsuario,
      IdIncidencia: paramEntity.GenericEntity.IdIncidencia,
      FechaDesde: paramEntity.GenericEntity.FechaDesde,
      FechaHasta: paramEntity.FechaDateArray[1],
      Dias: paramEntity.GenericEntity.Dias,
      Observaciones: paramEntity.GenericEntity.Observaciones,
      IdPatologia: paramEntity.GenericEntity.IdPatologia,
      IdJustificacion: paramEntity.GenericEntity.IdJustificacion,
      IdEstado: paramEntity.GenericEntity.IdEstado
    });
    
    this.novedadesService.updJustificacion(paramEntity).subscribe(
      (result: ResponseHelper) => {
        console.log('[EJECUTAR] Respuesta del servidor:', result);
        
        if (result.Ok) {
          this._snackBar.openSnackBar('snack-success', 
            'Justificación creada correctamente. La jerarquización puede demorar unos segundos en reflejarse.', 
            6000);
          
          console.log('[EJECUTAR] Refrescando grilla de avisos para legajo:', idLegajo);
          
          // Marcar el aviso como "en procesamiento" temporalmente
          const filasAfectadas = this.dataSourceAviso.data.filter(a => a.IdAviso === avisoHumand.IdAviso);
          filasAfectadas.forEach(fila => {
            fila.Observaciones = (fila.Observaciones || '') + ' [Procesando justificación...]';
          });
          this.dataSourceAviso.data = [...this.dataSourceAviso.data]; // Forzar actualización
          
          // Esperar 2 segundos antes de refrescar para dar tiempo a la jerarquización
          setTimeout(() => {
            this.getAvisosGrilla(idLegajo);
          }, 2000);
        } else {
          console.error('[EJECUTAR] Error en respuesta del servidor:', result.Mensaje);
          this._snackBar.openSnackBar('snack-danger', result.Mensaje, 3000);
        }
      },
      (error) => {
        console.error('[EJECUTAR] Error en llamada HTTP:', error);
        this._snackBar.openSnackBar('snack-danger', error.error, 3000);
      }
    );
  }

  openModalNomina() {
    const dialogRef = this.dialog.open(ModalNominaComponent, {
      width: '1000px',
      height: '550px',
      panelClass: 'modal-marcacion',
      autoFocus: false
    });
    dialogRef.beforeClosed().subscribe((result: Nomina) => {
      if (result) {
        Object.assign(this.aviso, result);
        this.getAvisosGrilla(this.aviso.IdLegajo);
      }
    });
  }

  calculaFecha(fechaPicker?) {
    fechaPicker = (!fechaPicker) ? this.fechaPicker : fechaPicker;
    if (this.aviso.Dias > 0 && this.aviso.Dias < 1000) {
      const result = new Date(fechaPicker);
      result.setDate(result.getDate() + Number(this.aviso.Dias));
      this.fechaCalculadaRetorno = result.toISOString();
      result.setDate(result.getDate() - 1);
      this.fechaCalculadaHasta = result.toISOString();
      return;
    }
    if (this.aviso.Dias === 0) {
      this._snackBar.openSnackBar('snack-danger', 'Debe ingresar un número superior a 0 (cero)', 3000);
      return;
    }
    this.fechaCalculadaRetorno = '';
    this.aviso.Dias = null;
  }

  soloNumeros(e) {
    if (!(e.keyCode === 8
      || e.keyCode === 46
      || (e.keyCode >= 35 && e.keyCode <= 40)
      || (e.keyCode >= 48 && e.keyCode <= 57)
      || (e.keyCode >= 96 && e.keyCode <= 105)
      || (e.keyCode === 86 && e.ctrlKey === true)
      || e.keyCode === 111)) {
      e.preventDefault();
    }
  }

  toggleMenuOpened() {
    this.menuMarcacionOpened = !this.menuMarcacionOpened;
  }

  openModalConfirmacion() {
    if (this.validarCampos()) {
      const dialogRef = this.dialog.open(ModalConfirmacionComponent, {
        width: '500px',
        height: '120px',
        autoFocus: false,
        data: {
          titulo: '¿Desea guardar el aviso?'
        }
      });
      dialogRef.beforeClosed().subscribe((result) => {
        if (result) {
          this.guardarAviso();
        }
      });
    }

  }

  validarCampos() {
    if (!this.aviso.IdIncidencia) {
      this._snackBar.openSnackBar('snack-danger', 'Seleccione una incidencia', 3000);
      return false;
    }
    if (!this.aviso.Dias) {
      this._snackBar.openSnackBar('snack-danger', 'Ingrese cantidad de días', 3000);
      return false;
    }
    return true;
  }

  setMostrarCmbPatologia() {
    this.cmbPatologiaHabilitado = this.aviso.IdIncidencia && this.listIncidenciasCmb.find(x => x.Id === this.aviso.IdIncidencia).IdPreSet === 1;
  }

}
